import axios from 'axios';
const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || '/api' });
api.interceptors.request.use(config => {
  const token = localStorage.getItem('packliste_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
api.interceptors.response.use(res => res, err => {
  if (err.response?.status === 401 || err.response?.status === 403) {
    localStorage.removeItem('packliste_token');
    window.location.href = '/login';
  }
  return Promise.reject(err);
});
export const authApi = {
  checkSetup: () => api.get('/auth/check-setup'),
  setup: (d) => api.post('/auth/setup', d),
  login: (d) => api.post('/auth/login', d),
};
export const kategorienApi = {
  list: () => api.get('/kategorien'),
  add: (d) => api.post('/kategorien', d),
  delete: (id) => api.delete(`/kategorien/${id}`),
};
export const itemsApi = {
  list: () => api.get('/items'),
  add: (d) => api.post('/items', d),
  update: (id, d) => api.put(`/items/${id}`, d),
  delete: (id) => api.delete(`/items/${id}`),
};
export const reisenApi = {
  list: () => api.get('/reisen'),
  add: (d) => api.post('/reisen', d),
  update: (id, d) => api.put(`/reisen/${id}`, d),
  delete: (id) => api.delete(`/reisen/${id}`),
  getItems: (id) => api.get(`/reisen/${id}/items`),
  addItems: (id, d) => api.post(`/reisen/${id}/items`, d),
  addFromMaster: (id, item_ids) => api.post(`/reisen/${id}/from-master`, { item_ids }),
  alleItems: (id) => api.post(`/reisen/${id}/alle-items`),
  updateItem: (reise_id, item_id, d) => api.put(`/reisen/${reise_id}/items/${item_id}`, d),
  deleteItem: (reise_id, item_id) => api.delete(`/reisen/${reise_id}/items/${item_id}`),
};
export default api;
